// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"0d38ff41","67":"0d38ff41","253":"0d38ff41","419":"0d38ff41","455":"0d38ff41","488":"3cc64b86","743":"0d38ff41","822":"0d38ff41","846":"47639877","931":"0d38ff41"}[chunkId] + ".chunk.css";
};